import { Injectable } from "@angular/core";
import { FileTranslationsStore } from "./file-translations.store";
import { selectMany } from "@ngneat/elf-entities";

@Injectable({ providedIn: "root" })
export class FileTranslationsQuery {
	constructor(private fileTranslationsStore: FileTranslationsStore) {}

	selectMany = (ids: string[]) => {
		return this.fileTranslationsStore.store.pipe(selectMany(ids));
	};
}
